import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, ArrowRight } from "lucide-react";
import api from "@/api/client";

export default function NewsletterUnsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ status: "loading", message: "" });

  useEffect(() => {
    if (!token) {
      setState({ status: "error", message: "Missing unsubscribe token." });
      return;
    }
    (async () => {
      try {
        const { data } = await api.get(`/newsletter/unsubscribe?token=${encodeURIComponent(token)}`);
        setState({ status: data.success ? "ok" : "error", message: data.message });
      } catch (e) {
        setState({ status: "error", message: "Could not process unsubscribe. Please try again." });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-6">
      <div className="max-w-md w-full border border-slate-800 rounded-xl p-8 text-center bg-gradient-to-b from-slate-900/60 to-transparent">
        {state.status === "loading" && (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-sky-400 mb-4" />
            <p className="text-sm text-slate-500">Processing your unsubscribe…</p>
          </>
        )}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="w-10 h-10 mx-auto text-emerald-400 mb-4" />
            <p className="font-serif text-2xl text-sky-100">Unsubscribed</p>
            <p className="text-sm text-slate-400 mt-3" data-testid="unsubscribe-success">{state.message}</p>
            <Link
              to="/"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-sky-400 hover:bg-sky-300 text-slate-950 rounded font-medium"
            >
              Back to home <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle className="w-10 h-10 mx-auto text-red-400 mb-4" />
            <p className="font-serif text-2xl text-sky-100">Link is invalid</p>
            <p className="text-sm text-slate-400 mt-3" data-testid="unsubscribe-error">{state.message}</p>
            <Link
              to="/"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 border border-slate-700 text-slate-300 hover:text-sky-300 hover:border-sky-500/40 rounded"
            >
              Back to home
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
